import { createIndexedDbDrawerWidthAdapter } from './indexedDbDrawerWidthAdapter.js';
import { withLocalStorageMigration } from './withLocalStorageMigration.js';

/** 패널 플래닝 drawer width 기본 저장소 (IndexedDB + localStorage 1회 마이그레이션) */
export const panelDrawerWidthStorage = withLocalStorageMigration(createIndexedDbDrawerWidthAdapter());
